import { createSlice } from '@reduxjs/toolkit';
import get from 'lodash/get';
import isString from 'lodash/isString';
import { pages as initialState } from '../initialState';
import { buildAsyncReducers } from '../thunkTemplate';
import { navigate, handleWebsocketMessage } from './_pages';

const { reducer, actions } = createSlice({
  name: 'pages',
  initialState,
  reducers: {
    setLoader(state, action) {
      state.loaderOpen = action.payload;
    },
    setWebsocketOrgId(state, action) {
      state.websocket.orgId = action.payload;
    },
    setWebsocketLastUpdate(state, action) {
      state.websocket.lastUpdate = action.payload;
    },
    setPage(state, action) {
      const page = action.payload.page;

      let id = isString(get(action, 'payload.id'))
        ? action.payload.id
        : state[page].id;

      state[page] = { id };
    },
  },
  extraReducers: (builder) => {
    buildAsyncReducers(builder, [navigate, handleWebsocketMessage]);
  },
});

const { setWebsocketOrgId, setWebsocketLastUpdate, setLoader, setPage } =
  actions;
export {
  setWebsocketOrgId,
  setWebsocketLastUpdate,
  setLoader,
  navigate,
  setPage,
  handleWebsocketMessage,
};
export default reducer;
